@if (!editMode || editReadOnly) {
  <div>
    @if (symbol !== undefined) {
      <span [innerHtml]="transform(symbol)"></span>
    }
    {{ displayMoneyValue }}
  </div>
} @else {
  @if (internalFormGroup) {
    <form [formGroup]="internalFormGroup" class="form-container">
      <div class="main-container">
        @if (!!internalFormGroup.getRawValue()['currency']) {
          <div class="adjust-elements">
            <span matPrefix [innerHtml]="data?.currency.symbol"></span>
            <input formControlName="valueMain" type="text" />
          </div>
        } @else {
          <div class="info">
            Select <br />
            currency!
          </div>
        }
        @if (shouldDisplaySmallUnit()) {
          .
          <div class="info-text">
            <input
              formControlName="valueSmall"
              type="text"
              pattern="{{ '[0-9]{' + this.numberOfDecimalPlaces + '}' }}" />
          </div>
        }
      </div>
    </form>
  }
}
